const MobileTableHeader = ({ title, description }) => {
  return (
    <div className="mb-3">
      <h3
        className="
          text-base
          font-semibold

          text-black
          dark:text-white
        "
      >
        {title}
      </h3>

      {description && (
        <p
          className="
            mt-1

            text-xs

            text-body
            dark:text-bodydark
          "
        >
          {description}
        </p>
      )}
    </div>
  );
};

export default MobileTableHeader;